﻿import * as React from 'react';
import moment from 'moment';
import { parse } from 'query-string';
import { UserRole } from '../../../../shared/types';

export function findPhotographerCalendarIndex(photographerId: number, calendar: unknown): number {
    for (let i = 0; i < calendar.dayNames.length; i++) {
        let pattern = /data-photographer-id="(\d+)"/;
        let match = pattern.exec(calendar.dayNames[i]);
        if (Number(match[1]) === photographerId) {
            return i;
        }
    }
    return -1;
}

export function isBookingRequest(
    calendarItem: unknown,
    desiredBookingInformation: unknown
): boolean {
    return calendarItem === null && !!desiredBookingInformation;
}

type OrderCommandForBooking = {
    products?: number[];
    brokerFirmId?: number | null;
};

export function firstBookableDateQueryArgs(
    orderCommandForBooking: OrderCommandForBooking | null,
    search: string
): { orderId: number | null; productIds: number[]; brokerFirmId: number | null } {
    if (orderCommandForBooking) {
        return {
            orderId: null,
            productIds: orderCommandForBooking.products || [],
            brokerFirmId: orderCommandForBooking.brokerFirmId || null
        };
    }

    let orderId = Number(parse(search).orderId);
    return { orderId: orderId > 0 ? orderId : null, productIds: [], brokerFirmId: null };
}

export function getDefaultBookingDate(now: Date, firstBookableDate: Date | null): Date {
    let startTime = { hour: 7, minute: 0, second: 0, millisecond: 0 };

    if (firstBookableDate !== null) {
        return moment(firstBookableDate).set(startTime).toDate();
    }

    let day = moment(now);
    let isFridayOrSaturday = day.isoWeekday() === 5 || day.isoWeekday() === 6;
    let nextWeekday = isFridayOrSaturday ? moment(now).isoWeekday(8) : moment(now).add(1, 'days');

    return nextWeekday.set(startTime).toDate();
}

// Same roles as UserRole.Se360UserRoles in the API: they skip the booking-day rules.
let rolesBypassingBookingRules: string[] = [
    UserRole.Admin,
    UserRole.Economist,
    UserRole.Management,
    UserRole.Support,
    UserRole.Seller
];

export function bypassesBookingRules(role: string | null | undefined): boolean {
    return rolesBypassingBookingRules.indexOf(role) !== -1;
}

// Keeps the first finished answer, so a later reload of the query cannot unmount the page.
export function useFirstFinishedValue<T>(value: T, isFinished: boolean): { isReady: boolean; value: T } {
    let first = React.useRef<{ value: T } | null>(null);
    if (first.current === null && isFinished) {
        first.current = { value };
    }

    return first.current === null
        ? { isReady: false, value }
        : { isReady: true, value: first.current.value };
}
